import React from 'react';
import Header from './components/Header';
import Form from './components/Form';

const ResetPassword: React.FC = () => {
  return (
    <div className="d-flex flex-column">
      <Header />
      <Form />
    </div>
  );
};

export default ResetPassword;
